import React, { useState, useEffect } from "react";
import { Box, Button } from "@mui/material";
import DeliveryOverview from "../../components/Delivery/DeliveryOverview";
import DeliveryAssignment from "../../components/Delivery/DeliveryAssignment";
import { useSearchParams } from "react-router-dom";

const Delivery = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedStatus, setSelectedStatus] = useState<string | null>(null);

  const [directPackageId, setDirectPackageId] = useState<string | null>(null);

  useEffect(() => {
    if (searchParams.get("action") === "assign") {
      setActiveTab(0);
      setSelectedStatus("Yet to be assigned");
      setSearchParams({});
    } else if (searchParams.get("packageId")) {
      setActiveTab(0);
      setDirectPackageId(searchParams.get("packageId"));
      setSearchParams({});
    }
  }, [searchParams, setSearchParams]);

  return (
    <Box sx={{ height: "100%", width: "100%", display: "flex", flexDirection: "column", p: 1, gap: 2 }}>
      <Box sx={{ display: "flex", gap: 2 }}>
        <Button
          onClick={() => setActiveTab(0)}
          variant={activeTab === 0 ? "contained" : "outlined"}
          sx={{ textTransform: "none", fontSize: "14px", fontWeight: 500, lineHeight: "20px", letterSpacing: "-0.15px", borderRadius: "6px", "&:hover": { bgcolor: activeTab === 0 ? "#005EFF" : "#FFF", borderColor: "rgba(74, 85, 101, 0.10)" }, ...(activeTab === 0 ? { bgcolor: "#005EFF" } : { border: "1px solid rgba(74, 85, 101, 0.10)", bgcolor: "#FFF", color: "#000814" }) }}
        >
          Delivery Overview
        </Button>
        <Button
          onClick={() => setActiveTab(1)}
          variant={activeTab === 1 ? "contained" : "outlined"}
          sx={{ textTransform: "none", fontSize: "14px", fontWeight: 500, lineHeight: "20px", letterSpacing: "-0.15px", borderRadius: "6px", "&:hover": { bgcolor: activeTab === 1 ? "#005EFF" : "#FFF", borderColor: "rgba(74, 85, 101, 0.10)" }, ...(activeTab === 1 ? { bgcolor: "#005EFF" } : { border: "1px solid rgba(74, 85, 101, 0.10)", bgcolor: "#FFF", color: "#000814" }) }}
        >
          Delivery assignments
        </Button>
      </Box>

      {activeTab === 0 && <DeliveryOverview selectedStatus={selectedStatus} onStatusChange={() => setSelectedStatus(null)} directPackageId={directPackageId} onDirectPackageIdConsumed={() => setDirectPackageId(null)} />}
      {activeTab === 1 && <DeliveryAssignment />}
    </Box>
  );
};
export default Delivery;
